import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "./utils/axios";
import { ThemeProvider } from "./contexts/ThemeContext";
import { BotProvider } from "./contexts/BotContext";
import LoadingScreen from "./components/LoadingScreen";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import ServerDetails from "./pages/ServerDetails";
import AddBot from "./pages/AddBot";
import "./App.css";
import AdminPanel from "./pages/AdminPanel";

interface User {
  id: string;
  username: string;
  discriminator: string;
  avatar: string | null;
  isAdmin?: boolean;
}

function App() {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is authenticated
    axios
      .get("/api/auth/status")
      .then((response) => {
        if (response.data.authenticated) {
          setUser(response.data.user);
        }
      })
      .catch(() => {
        // Not authenticated
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <ThemeProvider>
        <BotProvider>
          <LoadingScreen />
        </BotProvider>
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider>
      <BotProvider>
        <Router>
          <Routes>
            <Route
              path="/"
              element={user ? <Navigate to="/dashboard" /> : <Login />}
            />
            <Route
              path="/dashboard"
              element={user ? <Dashboard user={user} /> : <Navigate to="/" />}
            />
            <Route
              path="/server/:guildId"
              element={
                user ? <ServerDetails user={user} /> : <Navigate to="/" />
              }
            />
            <Route
              path="/add-bot"
              element={user ? <AddBot user={user} /> : <Navigate to="/" />}
            />
            <Route
              path="/admin"
              element={
                user && user.isAdmin ? (
                  <AdminPanel user={user} />
                ) : (
                  <Navigate to="/dashboard" />
                )
              }
            />
          </Routes>
        </Router>
      </BotProvider>
    </ThemeProvider>
  );
}

export default App;
